const getKetchId = (win: Window & typeof globalThis) => {
  const endsWith = (a: string) => win.location.host.endsWith(a);

  if (endsWith('valuepenguin.com')) {
    return 'value_penguin';
  }

  if (endsWith('snapcap.com')) {
    return 'snap_cap';
  }

  return 'website_smart_tag';
};

export const addKetchLoader = (win: Window & typeof globalThis, doc: Document) => {
  win.semaphore = win.semaphore || [];
  win.ketch = (...args: unknown[]) => {
    win.semaphore.push(args);
  };
  const e = doc.createElement('script');
  e.type = 'text/javascript';
  e.src = `https://global.ketchcdn.com/web/v3/config/lendingtree/${getKetchId(win)}/boot.js`;
  e.defer = e.async = true;
  doc.getElementsByTagName('head')[0].appendChild(e);
};
